import styled from 'styled-components'

export const BookingItemContainer = styled.div`
  margin: 26px 0px;
  margin-left: 41px;
  margin-right: 80px;
  display: flex;
  justify-content: space-between;
`

export const BookingItemTitle = styled.p<{ available: boolean }>`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.main};
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 130%;
  display: flex;
  align-items: center;
  color: ${({ available }) =>
    available ? '#3b3b3b' : 'rgba(59, 59, 59, 0.5);'};
`

export const BookingItemNotAvailable = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 130%;
  color: rgba(244, 83, 83, 0.5);
`

export const BookingItemReservedContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const BookingItemReserved = styled.p`
  margin: 0;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 130%;
  color: #88e8b0;
`

export const BookingItemEditButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 40px;
  height: 40px;
  background: #f5f5f5;
  border-radius: 8px;
`
